{
  "name": "fitogest",
  "version": "19.40.1",
  "license": "UNLICENSED",
  "type": "module",
  "scripts": {
    "compile": "node buildWithInput.mjs",
    "start": "ng serve Fitogest",
    "start-fichajes": "ng serve Fichajes",
    "build-fichajes": "ng build Fichajes  --base-href /fichajes/",
    "angular-update": "ng update @angular/core@19 @angular/cli@19 --allow-dirty --force",
    "lint": "ng lint",
    "test": "jest",
    "test:watch": "jest --watch",
    "test:ci": "jest --runInBand",
    "e2e": "ng e2e",
    "bundle": "npm pack",
    "zip:support": "node tools/create-support-zip.mjs",
    "compodoc": "compodoc -p src/tsconfig.app.json -s",
    "ng": "ng",
    "validate:reactive-form-builder": "node tools/validate-reactive-form-builder.mjs",
    "validate:reactive-form-builder:full": "node tools/validate-reactive-form-builder.mjs --install",
    "validate:reactive-form-builder:lint": "node tools/validate-reactive-form-builder.mjs --lint --skip-build --skip-tests",
    "validate:tratamientos-control": "node tools/validate-tratamientos-control.mjs",
    "pack:reactive-form-builder": "npm run build:reactive-form-builder:production && npm pack ./dist/reactive-form-builder",
    "pack:reactive-form-builder:dry-run": "npm run build:reactive-form-builder:production && npm pack ./dist/reactive-form-builder --dry-run",
    "build:reactive-form-builder": "node tools/clean-reactive-form-builder-source-entrypoints.mjs && ng build reactive-form-builder && node tools/finalize-reactive-form-builder-package.mjs",
    "build:reactive-form-builder:development": "node tools/clean-reactive-form-builder-source-entrypoints.mjs && ng build reactive-form-builder --configuration development && node tools/finalize-reactive-form-builder-package.mjs",
    "build:reactive-form-builder:production": "node tools/clean-reactive-form-builder-source-entrypoints.mjs && ng build reactive-form-builder --configuration production && node tools/finalize-reactive-form-builder-package.mjs",
    "audit:reactive-form-builder:legacy": "node tools/audit-reactive-form-builder-legacy-imports.mjs",
    "verify:reactive-form-builder": "npm run audit:reactive-form-builder:legacy:strict && npm run audit:reactive-form-builder:public-api && npm run audit:reactive-form-builder:api-stability && npm run audit:reactive-form-builder:root-public-api && npm run audit:reactive-form-builder:alias-runtime && npm run audit:reactive-form-builder:ci && npm run test:reactive-form-builder:contracts && npm run test:reactive-form-builder:template-contracts && npm run test:reactive-form-builder:generic-hosts && npm run test:reactive-form-builder:aligned-hosts && npm run test:fitogest-build-diagnostics && npm run test:fitogest-template-warnings && npm run test:browser-node-only-imports && npm run test:fitogest-global-script-budget && npm run test:fitogest-word-export-service && npm run test:fitogest-lazy-heavy-imports && npm run test:fitogest-lazy-pdf-imports && npm run test:fitogest-native-date-time && npm run test:fitogest-moment-import-audit && npm run test:reactive-request-helper-library:contracts && npm run test:mantenimiento-reactive-form:contracts && npm run test:mto-reactive-form:contracts && npm run audit:reactive-form-builder:consumer-hygiene && npm run report:reactive-form-builder:legacy-debt && npm run test:reactive-form-builder:field-factories && npm run test:reactive-form-builder:host-controller && npm run test:reactive-form-builder:submit-orchestration && npm run test:reactive-form-builder:submit-executors && npm run test:reactive-form-builder:submit-error-policy && npm run test:reactive-form-builder:submit-completion-policy && npm run test:reactive-form-builder:submit-host-bridge && npm run test:reactive-form-builder:submit-hardening && npm run test:reactive-form-builder:repeatables-modal && npm run test:reactive-form-builder:modal-advanced && npm run test:reactive-form-builder:repeatable-group-factory && npm run test:reactive-form-builder:repeatable-domain-adapters && npm run test:non-mto-reactive-form:contracts && npm run test:analisis-ventas-reactive-form:contracts && npm run test:parcelas-reactive-form:contracts && npm run test:productos-reactive-form:contracts && npm run test:tratamientos-reactive-form:contracts && npm run test:tareas-reactive-form:contracts && npm run test:stock-entradas-reactive-form:contracts && npm run test:stock-salidas-reactive-form:contracts && npm run test:stock-trazabilidad-reactive-form:contracts && npm run test:stock-balances-reactive-form:contracts && npm run test:visitas-reactive-form:contracts && npm run test:visitas-secondary-reactive-form:contracts && npm run test:reactive-form-builder:unit && npm run test:reactive-form-builder:playground && npm run build:reactive-form-builder:production && npm pack ./dist/reactive-form-builder --dry-run && npm run test:reactive-form-builder:package-smoke",
    "release:reactive-form-builder:local": "npm run verify:reactive-form-builder && npm pack ./dist/reactive-form-builder",
    "audit:reactive-form-builder:legacy:strict": "node tools/audit-reactive-form-builder-legacy-imports.mjs --strict-app-imports",
    "audit:reactive-form-builder:public-api": "node tools/clean-reactive-form-builder-source-entrypoints.mjs && node tools/audit-reactive-form-builder-public-api.mjs",
    "test:reactive-form-builder:contracts": "node tools/clean-reactive-form-builder-source-entrypoints.mjs && node tools/test-reactive-form-builder-contracts.mjs",
    "test:mantenimiento-reactive-form:contracts": "node tools/test-mantenimiento-reactive-form-contracts.mjs",
    "test:reactive-form-builder:playground": "node tools/check-reactive-form-builder-playground.mjs",
    "publish:reactive-form-builder": "node tools/release-reactive-form-builder.mjs",
    "publish:reactive-form-builder:dry-run": "node tools/release-reactive-form-builder.mjs --dry-run",
    "audit:reactive-form-builder:ci": "node tools/check-reactive-form-builder-ci-config.mjs",
    "test:reactive-form-builder:package-smoke": "node tools/smoke-test-reactive-form-builder-package.mjs",
    "test:reactive-form-builder:package-smoke:source": "node tools/clean-reactive-form-builder-source-entrypoints.mjs && node tools/smoke-test-reactive-form-builder-package.mjs --source-only",
    "ci:reactive-form-builder": "npm run verify:reactive-form-builder && npm run build",
    "test:reactive-form-builder:unit": "jest --runInBand --testMatch \"<rootDir>/projects/reactive-form-builder/src/lib/**/*.test.ts\"",
    "audit:reactive-form-builder:api-stability": "node tools/check-reactive-form-builder-api-stability.mjs",
    "audit:reactive-form-builder:alias-runtime": "node tools/check-reactive-form-builder-alias-runtime-exports.mjs",
    "audit:reactive-form-builder:root-public-api": "node tools/check-reactive-form-builder-root-public-api.mjs",
    "report:reactive-form-builder:entrypoint-migration": "node tools/report-reactive-form-builder-entrypoint-migration.mjs",
    "report:reactive-form-builder:entrypoint-migration:markdown": "node tools/report-reactive-form-builder-entrypoint-migration.mjs --markdown=validation-reports/reactive-form-builder-entrypoint-migration.md",
    "report:reactive-form-builder:release-readiness": "node tools/report-reactive-form-builder-release-readiness.mjs",
    "report:reactive-form-builder:release-readiness:markdown": "node tools/report-reactive-form-builder-release-readiness.mjs --markdown=validation-reports/reactive-form-builder-release-readiness.md",
    "build": "ng build Fitogest",
    "test:mto-riego-reactive-form:contracts": "node tools/test-mto-reactive-form-contracts.mjs",
    "test:mto-reactive-form:contracts": "node tools/test-mto-reactive-form-contracts.mjs",
    "test:non-mto-reactive-form:contracts": "node tools/test-non-mto-reactive-form-contracts.mjs",
    "test:analisis-ventas-reactive-form:contracts": "node tools/test-analisis-ventas-reactive-form-contracts.mjs",
    "audit:reactive-form-builder:consumer-hygiene": "node tools/audit-reactive-form-consumers.mjs --strict",
    "test:stock-entradas-reactive-form:contracts": "node tools/test-stock-entradas-reactive-form-contracts.mjs",
    "test:stock-salidas-reactive-form:contracts": "node tools/test-stock-salidas-reactive-form-contracts.mjs",
    "test:productos-reactive-form:contracts": "node tools/test-productos-reactive-form-contracts.mjs",
    "test:tratamientos-reactive-form:contracts": "node tools/test-tratamientos-reactive-form-contracts.mjs",
    "test:tareas-reactive-form:contracts": "node tools/test-tareas-reactive-form-contracts.mjs",
    "report:reactive-form-builder:legacy-debt": "node tools/report-reactive-form-legacy-debt.mjs",
    "report:reactive-form-builder:legacy-debt:markdown": "node tools/report-reactive-form-legacy-debt.mjs --markdown=docs/reactive-form-builder/legacy-debt-report.md",
    "test:reactive-request-helper-library:contracts": "node tools/test-reactive-request-helper-library-contracts.mjs",
    "test:parcelas-reactive-form:contracts": "node tools/test-parcelas-reactive-form-contracts.mjs",
    "test:stock-trazabilidad-reactive-form:contracts": "node tools/test-stock-trazabilidad-reactive-form-contracts.mjs",
    "test:stock-balances-reactive-form:contracts": "node tools/test-stock-balances-reactive-form-contracts.mjs",
    "test:visitas-reactive-form:contracts": "node tools/test-visitas-reactive-form-contracts.mjs",
    "test:visitas-secondary-reactive-form:contracts": "node tools/test-visitas-secondary-reactive-form-contracts.mjs",
    "zip:support:source": "SUPPORT_DEPS_MODE=none node tools/create-support-zip.mjs",
    "zip:support:cache": "SUPPORT_DEPS_MODE=cache node tools/create-support-zip.mjs",
    "support:restore-deps": "node tools/restore-support-dependencies.mjs",
    "test:reactive-form-builder:field-factories": "node tools/test-reactive-form-field-factory-contracts.mjs",
    "test:reactive-form-builder:host-controller": "node tools/test-reactive-form-host-controller-contracts.mjs",
    "test:reactive-form-builder:submit-orchestration": "node tools/test-reactive-form-submit-orchestration-contracts.mjs",
    "test:reactive-form-builder:submit-executors": "node tools/test-reactive-form-submit-executor-contracts.mjs",
    "test:reactive-form-builder:submit-error-policy": "node tools/test-reactive-form-submit-error-policy-contracts.mjs",
    "test:reactive-form-builder:submit-completion-policy": "node tools/test-reactive-form-submit-completion-policy-contracts.mjs",
    "test:reactive-form-builder:submit-host-bridge": "node tools/test-reactive-form-submit-host-bridge-contracts.mjs",
    "test:reactive-form-builder:submit-hardening": "node tools/test-reactive-form-submit-hardening-contracts.mjs",
    "test:reactive-form-builder:repeatables-modal": "node tools/test-reactive-form-repeatables-modal-contracts.mjs",
    "test:reactive-form-builder:modal-advanced": "node tools/test-reactive-form-modal-advanced-contracts.mjs",
    "test:reactive-form-builder:repeatable-group-factory": "node tools/test-reactive-form-repeatable-group-factory-contracts.mjs",
    "test:reactive-form-builder:repeatable-domain-adapters": "node tools/test-reactive-form-repeatable-domain-adapter-contracts.mjs",
    "test:reactive-form-builder:repeatable-magrama-boundary": "node tools/test-reactive-form-repeatable-magrama-boundary-contracts.mjs",
    "test:reactive-form-builder:template-contracts": "node tools/test-reactive-form-template-contracts.mjs",
    "test:reactive-form-builder:generic-hosts": "node tools/test-reactive-form-generic-host-contracts.mjs",
    "diagnose:fitogest-build": "node tools/profile-fitogest-build.mjs",
    "diagnose:fitogest-build:run": "node tools/profile-fitogest-build.mjs --run --timeout-ms=120000",
    "test:reactive-form-builder:aligned-hosts": "node tools/test-reactive-form-aligned-host-contracts.mjs",
    "diagnose:fitogest-build:matrix": "node tools/diagnose-fitogest-build-scenarios.mjs",
    "diagnose:fitogest-build:matrix:run": "node tools/diagnose-fitogest-build-scenarios.mjs --run --timeout-ms=180000",
    "test:fitogest-build-diagnostics": "node tools/test-fitogest-build-diagnostics-contracts.mjs",
    "test:browser-node-only-imports": "node tools/test-browser-node-only-import-contracts.mjs",
    "test:fitogest-template-warnings": "node tools/test-fitogest-template-warning-contracts.mjs",
    "test:fitogest-global-script-budget": "node tools/test-fitogest-global-script-budget-contracts.mjs",
    "test:fitogest-word-export-service": "node tools/test-fitogest-word-export-service-contracts.mjs",
    "test:fitogest-lazy-heavy-imports": "node tools/test-fitogest-lazy-heavy-import-contracts.mjs",
    "test:fitogest-native-date-time": "node tools/test-fitogest-native-date-time-contracts.mjs",
    "report:fitogest-moment-imports": "node tools/report-fitogest-moment-imports.mjs",
    "test:fitogest-moment-import-audit": "node tools/test-fitogest-moment-import-audit-contracts.mjs",
    "test:fitogest-lazy-pdf-imports": "node tools/test-fitogest-lazy-pdf-import-contracts.mjs"
  },
  "dependencies": {
    "@angular/animations": "19.1.0",
    "@angular/cdk": "19.1.0",
    "@angular/common": "19.1.0",
    "@angular/compiler": "19.1.0",
    "@angular/core": "19.1.0",
    "@angular/forms": "19.1.0",
    "@angular/localize": "19.1.0",
    "@angular/platform-browser": "19.1.0",
    "@angular/platform-browser-dynamic": "19.1.0",
    "@angular/pwa": "19.1.0",
    "@angular/router": "19.1.0",
    "@angular/service-worker": "19.1.0",
    "@babel/core": "7.26.0",
    "@fullcalendar/angular": "6.1.16",
    "@fullcalendar/core": "6.1.15",
    "@fullcalendar/daygrid": "6.1.15",
    "@fullcalendar/interaction": "6.1.15",
    "@fullcalendar/timegrid": "6.1.15",
    "@google/maps": "1.1.3",
    "@n8n/chat": "0.58.0",
    "@ng-bootstrap/ng-bootstrap": "18.0.0",
    "@ngx-env/builder": "^19.1.0",
    "@northpoint-labs/vector-tiles-google-maps": "1.1.0",
    "@popperjs/core": "2.11.8",
    "@primeng/themes": "19.0.6",
    "@primer/octicons": "19.12.0",
    "acorn": "8.14.0",
    "ajv": "8.17.1",
    "bootstrap": "5.3.3",
    "buffer": "6.0.3",
    "canvg": "^4.0.2",
    "chart.js": "4.4.6",
    "chartjs-plugin-zoom": "^2.2.0",
    "core-js": "3.39.0",
    "crypto-js": "4.2.0",
    "dexie": "4.0.9",
    "font-awesome": "4.7.0",
    "fullcalendar": "6.1.15",
    "html2canvas": "1.4.1",
    "html2pdf": "0.0.11",
    "html2pdf-fix-jspdf": "0.0.4",
    "html2pdf.js": "0.10.2",
    "jquery": "3.7.1",
    "jspdf": "^2.5.2",
    "jspdf-autotable": "^5.0.2",
    "jspdf-fix-png": "1.4.2",
    "moment": "2.30.1",
    "ngx-ui-tour-primeng": "1.0.0",
    "node-gyp": "10.2.0",
    "ora": "^8.0.1",
    "pdf-text-extract": "1.5.0",
    "pdf-to-text": "0.0.7",
    "pdfmake": "0.2.18",
    "primeicons": "7.0.0",
    "primeng": "19.0.6",
    "quill": "2.0.2",
    "rxjs": "7.8.1",
    "sass": "1.69.5",
    "signature_pad": "5.0.2",
    "stream": "0.0.3",
    "timers": "0.1.1",
    "tippy.js": "6.3.7",
    "ts-md5": "1.3.1",
    "util": "0.12.5",
    "xml2js": "0.6.2",
    "zone.js": "0.15.0",
    "@fitogest/reactive-form-builder": "file:projects/reactive-form-builder"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.1.0",
    "@angular/cli": "19.1.0",
    "@angular/compiler-cli": "19.1.0",
    "@angular/language-service": "19.1.0",
    "@compodoc/compodoc": "1.1.26",
    "@jest/globals": "29.7.0",
    "@tsconfig/strictest": "2.0.5",
    "@types/eslint-config-prettier": "^6.11.3",
    "@types/jest": "29.5.14",
    "@types/jquery": "3.5.31",
    "@types/pdfmake": "0.2.11",
    "@types/primer__octicons": "19.11.0",
    "@types/xml2js": "0.4.14",
    "angular-eslint": "18.1.0",
    "eslint": "9.14.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-html": "8.1.2",
    "eslint-plugin-prettier": "^5.5.4",
    "eslint-plugin-promise": "7.1.0",
    "globals": "15.12.0",
    "jest": "29.7.0",
    "jest-preset-angular": "14.5.3",
    "prettier": "^3.7.4",
    "process": "0.11.10",
    "protractor": "7.0.0",
    "sharp": "0.33.5",
    "ts-node": "10.9.2",
    "ts-string-literal-enum-plugin": "0.0.3",
    "typescript": "5.7.3",
    "typescript-eslint": "8.37.0",
    "typescript-todo-or-die-plugin": "0.6.0",
    "ng-packagr": "^19.0.0"
  },
  "engines": {
    "node": ">=18.19.0",
    "npm": ">=10.2.4"
  },
  "jest": {
    "preset": "jest-preset-angular",
    "setupFilesAfterEnv": [
      "./setup-jest.ts"
    ],
    "testEnvironment": "jsdom",
    "transform": {
      "^.+\\.(ts|js|html)$": [
        "jest-preset-angular",
        {
          "tsconfig": "src/tsconfig.spec.json",
          "stringifyContentPathRegex": "\\.html$"
        }
      ]
    },
    "moduleNameMapper": {
      "^src/(.*)$": "<rootDir>/src/$1"
    }
  },
  "private": true,
  "bundleDependencies": [
    "@angular/animations",
    "@angular/cdk",
    "@angular/common",
    "@angular/compiler",
    "@angular/core",
    "@angular/forms",
    "@angular/localize",
    "@angular/platform-browser",
    "@angular/platform-browser-dynamic",
    "@angular/pwa",
    "@angular/router",
    "@angular/service-worker",
    "@babel/core",
    "@fullcalendar/angular",
    "@fullcalendar/core",
    "@fullcalendar/daygrid",
    "@fullcalendar/interaction",
    "@fullcalendar/timegrid",
    "@google/maps",
    "@n8n/chat",
    "@ng-bootstrap/ng-bootstrap",
    "@northpoint-labs/vector-tiles-google-maps",
    "@popperjs/core",
    "acorn",
    "ajv",
    "bootstrap",
    "buffer",
    "chart.js",
    "core-js",
    "crypto-js",
    "dexie",
    "font-awesome",
    "fullcalendar",
    "html2canvas",
    "html2pdf",
    "html2pdf-fix-jspdf",
    "html2pdf.js",
    "jspdf",
    "jspdf-fix-png",
    "moment",
    "node-gyp",
    "sass",
    "@primer/octicons",
    "ora",
    "pdf-text-extract",
    "pdf-to-text",
    "primeicons",
    "primeng",
    "ngx-ui-tour-primeng",
    "quill",
    "rxjs",
    "signature_pad",
    "stream",
    "timers",
    "tippy.js",
    "ts-md5",
    "util",
    "xml2js",
    "zone.js"
  ],
  "workspaces": [
    "projects/reactive-form-builder"
  ]
}
